import axios from "axios";
import { authHeader } from "./utils";
import { GET_DETECTOR, LIST_DETECTOR, LIST_DETECTOR_EVENT } from "./types";

export const getDetector = (id) => async (dispatch) => {
  const res = await axios.get(`/api/detectors/${id}`, {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: GET_DETECTOR, payload: res.data });
};

export const fetchDetectors =
  ({ page, limit, all }) =>
  async (dispatch) => {
    const res = await axios.get("/api/detectors", {
      headers: authHeader(),
      params: { page, limit, all },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_DETECTOR, payload: res.data });
  };

export const submitDetector =
  ({ detector }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.post("/api/detectors", detector, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const updateDetector =
  ({ detector, id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.put(`/api/detectors/${id}`, detector, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const deleteDetector =
  ({ id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/api/detectors/${id}`, {
          headers: authHeader(),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });

export const fetchDetectorEvents = () => async (dispatch) => {
  const res = await axios.get(`/api/detectors/events`, {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: LIST_DETECTOR_EVENT, payload: res.data });
};
